import React, { useEffect, useRef, useState } from "react";

const KeySystemModulesSection = ({ modules }) => {
  const sectionRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <section className="key-system-modules-section py-5" ref={sectionRef}>
      <div className="container">
        <h2 className="text-center fw-bold mb-5 text-dark text-uppercase">
          Key System Modules
        </h2>
        <div className="row g-4">
          {modules.map((module, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div
                className={`module-card shadow-sm ${
                  isVisible ? "slide-from-top" : ""
                }`}
              >
                <div className="module-card-header d-flex align-items-center gap-2 p-3">
                  <div className="module-number-circle">{i + 1}</div>
                  <h5 className="mb-0 text-white fw-bold">{module.title}</h5>
                </div>
                <div className="module-card-body">
                  <ul className="mb-0 ps-3">
                    {module.features.map((feature, j) => (
                      <li key={j}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeySystemModulesSection;
